import { ref } from 'vue';

const initialState = Object.freeze({
  accordionActiveIndex: -1,
  sortBySelectedValue: '',
  facets: [],
});

const selections = ref({ ...initialState });

export default function useSortFilter() {
  const buildSections = (view) => {
    selections.value.sortBySelectedValue = view.sortBySelectedValue;
    selections.value.facets = JSON.parse(JSON.stringify(view.facets));

    if (view.facetId !== 'filter') {
      selections.value.accordionActiveIndex = selections.value.facets.findIndex((v) => v.name === view.facetId);
    } else {
      selections.value.accordionActiveIndex = initialState.accordionActiveIndex;
    }
  };

  const updateSortBy = (value) => {
    selections.value.sortBySelectedValue = value;
  };

  const updateFacet = (criteria) => {
    const facet = selections.value.facets.filter((_facet) => _facet.name === criteria.name);
    if (facet.length > 0) {
      facet[0].selectedValues = criteria.selectedValues;
    }
  };

  const addCheckboxValue = (criteria) => {
    const facet = selections.value.facets.filter((_facet) => _facet.name === criteria.name);
    if (facet.length > 0) {
      facet[0].values.push(criteria.newValue);
    }
  };

  const facetByName = (name) => selections.value.facets.filter((facet) => facet.name === name)[0];

  const removeCheckBoxValuesByValue = (criteria) => {
    const facet = selections.value.facets.filter((_facet) => _facet.name === criteria.name);
    if (facet.length > 0) {
      facet[0].values = facet[0].values.filter((value) => value.value !== criteria.value);
    }
  };

  const resetSelections = () => {
    selections.value = { ...initialState };
  };

  const clearAllSelectedFacets = () => {
    selections.value.facets
      .filter((facet) => facet.selectedValues.length > 0)
      .forEach((facet) => {
        facet.selectedValues = [];
      });
  };

  return {
    addCheckboxValue,
    removeCheckBoxValuesByValue,
    resetSelections,
    clearAllSelectedFacets,
    updateSortBy,
    updateFacet,
    facetByName,
    buildSections,
    selections,
  };
}
